import PLANS_DOMAIN from './domain'
import { PLANS_KEY } from './key'

const PLANS_PATH = {
  ALL: `${PLANS_DOMAIN}.${PLANS_KEY.ALL}`,
  ALL_DATA: `${PLANS_DOMAIN}.${PLANS_KEY.ALL}.data`,
  LOGGED: `${PLANS_DOMAIN}.${PLANS_KEY.LOGGED}`,
  LOGGED_DATA: `${PLANS_DOMAIN}.${PLANS_KEY.LOGGED}.data`,
  CHALLENGES: `${PLANS_DOMAIN}.${PLANS_KEY.CHALLENGES}`,
  NON_LOGGED: `${PLANS_DOMAIN}.${PLANS_KEY.NON_LOGGED}`,
  NON_LOGGED_DATA: `${PLANS_DOMAIN}.${PLANS_KEY.NON_LOGGED}.data`,
  CURRENT: `${PLANS_DOMAIN}.${PLANS_KEY.CURRENT}`,
  STARTED: `${PLANS_DOMAIN}.${PLANS_KEY.STARTED}`,
  SUGGESTED: `${PLANS_DOMAIN}.${PLANS_KEY.SUGGESTED}`,
  DATA: `${PLANS_DOMAIN}.${PLANS_KEY.DATA}`,
  SMART: `${PLANS_DOMAIN}.${PLANS_KEY.SMART}`,
  SMART_VALUE: `${PLANS_DOMAIN}.${PLANS_KEY.SMART}.value`,
  RECOMMENDED: `${PLANS_DOMAIN}.${PLANS_KEY.RECOMMENDED}`,
  RECOMMENDED_DATA: `${PLANS_DOMAIN}.${PLANS_KEY.RECOMMENDED}.data`
}

export default PLANS_PATH
